import React from "react";
import { useParams } from "react-router";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import userInfo from "../user/UserExample";
import TypeUser from "../user/TypeUser";
import invoices from "./invoices";
import helpersNumbers from "../../../helpers/numbers";
import { Link } from "react-router-dom";

export default function OfficialInvoice() {
  const params = useParams();
  const invoiceID = params.id;

  const generateOfficialInvoice = () => {
    let invoice = invoices.filter((item) => item.id == invoiceID);
    invoice = invoice[0];
    const amountWithoutVAT = Math.floor(
      (invoice.amount * 100) /
        (100 + parseInt(process.env.REACT_APP_TAX_PERCENT_AMOUNT_CHARGE))
    );

    let amountVAT =
      Math.floor(
        amountWithoutVAT *
          parseInt(process.env.REACT_APP_TAX_PERCENT_AMOUNT_CHARGE)
      ) / 100;

    return (
      <div>
        <div
          id="official-invoice-confiner"
          className="py-2 "
          style={{ overflowX: "auto" }}
        >
          <div style={{ minWidth: "900px", width: "100%" }}>
            <div className="d-flex align-items-center pb-2 ">
              <div style={{ width: "33.3%" }}>
                <span>
                  <img
                    style={{ width: "20%" }}
                    src="/assets/img/mat-credit-logo.png"
                  />
                </span>
              </div>

              <div className="text-center" style={{ width: "33.3%" }}>
                پیش فاکتور
              </div>

              <div
                style={{ width: "33.3%" }}
                dir="ltr"
                className="d-flex flex-column "
              >
                <span className="pb-2 d-flex">
                  <span
                    className="border border-1 border-dark  "
                    style={{ width: "100px" }}
                  ></span>
                  <span className="pl-1">: شماره سریال</span>
                </span>
                <span className="d-flex">
                  <span
                    className="border border-1 border-dark text-center "
                    style={{ width: "100px", letterSpacing: "2px" }}
                  >
                    {helpersNumbers.toPersianNum(invoice.paid_at.split(" ")[0])}
                  </span>
                  <span className="pl-1">: تاریخ</span>
                </span>
              </div>
            </div>
            <div className="border border-1 border-dark border-bottom-0 ">
              <div className="text-center border-bottom border-dark py-2">
                مشخصات فروشنده
              </div>
              <div className="text-center border-bottom border-dark py-2">
                <div className="d-flex align-items-center justify-content-between p-2 ">
                  <div>
                    <span className="pl-1">نام شخص حقیقی / حقوقی :</span>
                    <span>شرکت فن آوای هوش مصنوعی</span>
                  </div>
                  <div>
                    <span className="pl-1">شماره اقتصادی :</span>
                    <span className="letter-spacing-finance-number">
                      ۱۴۰۰۹۵۰۵۴۷
                    </span>
                  </div>
                  <div>
                    <span className="pl-1">شماره ثبت :</span>
                    <span className="letter-spacing-finance-number">
                      ۵۶۶۷۶۵
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between p-2 ">
                  <div>
                    <span>نشانی کامل : استان : </span>
                    <span>تهران</span>
                  </div>
                  <div>
                    <span>شهر : </span>
                    <span>تهران</span>
                  </div>
                  <div>
                    <span>شهرستان : </span>
                    <span>تهران</span>
                  </div>
                  <div>
                    <span>کد پستی ۱۰ رقمی : </span>
                    <span className="letter-spacing-finance-number">
                      ۱۱۳۷۹۵۸۶۱۷
                    </span>
                  </div>
                  <div>
                    <span className="pl-1">شناسه ملی : </span>
                    <span className="letter-spacing-finance-number">
                      ۱۴۰۰۹۵۰۵۴۷
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between p-2 ">
                  <div>
                    <span>نشانی : </span>
                    <span>میدان حسن آباد کوچه نعمتی پلاک ۲۰ واحد ۸</span>
                  </div>

                  <div>
                    <span>تلفن : </span>
                    <span className="letter-spacing-finance-number">
                      ۰۲۱۶۶۷۵۷۳۷۹
                    </span>
                  </div>
                </div>
              </div>
              <div className="text-center border-bottom border-dark py-2">
                مشخصات خریدار
              </div>
              <div className="text-center border-bottom border-dark py-2">
                <div className="d-flex align-items-center justify-content-between p-2 ">
                  <div>
                    <span className="pl-1">نام شخص حقیقی / حقوقی :</span>
                    <span>
                      {userInfo.firstName}{" "}
                      {userInfo.type == TypeUser.userType.REAL
                        ? userInfo.lastName
                        : ""}
                    </span>
                  </div>
                  <div>
                    <span className="pl-1">شماره اقتصادی :</span>
                    <span className="letter-spacing-finance-number">
                      {userInfo.type == TypeUser.userType.LEGAL
                        ? helpersNumbers.toPersianNum(userInfo.economic_number)
                        : "-"}
                    </span>
                  </div>
                  <div>
                    <span className="pl-1">شماره ثبت :</span>
                    <span className="letter-spacing-finance-number">
                      {userInfo.type == TypeUser.userType.LEGAL
                        ? helpersNumbers.toPersianNum(userInfo.register_number)
                        : "-"}
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between p-2 ">
                  <div>
                    <span>نشانی کامل : استان : </span>
                    <span>{userInfo.state}</span>
                  </div>
                  <div>
                    <span>شهر : </span>
                    <span>{userInfo.city}</span>
                  </div>
                  <div>
                    <span>شهرستان : </span>
                    <span>{userInfo.town}</span>
                  </div>
                  <div>
                    <span>کد پستی ۱۰ رقمی : </span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(userInfo.postal_code)}
                    </span>
                  </div>
                  <div>
                    <span>
                      {userInfo.type == TypeUser.userType.REAL ? "کد ملی" : ""}
                      {userInfo.type == TypeUser.userType.LEGAL
                        ? "شناسه ملی"
                        : ""}{" "}
                      :
                    </span>
                    <span className="letter-spacing-finance-number pr-1">
                      {userInfo.type == TypeUser.userType.REAL
                        ? helpersNumbers.toPersianNum(userInfo.national_code)
                        : ""}
                      {userInfo.type == TypeUser.userType.LEGAL
                        ? helpersNumbers.toPersianNum(
                            userInfo.identity_national
                          )
                        : ""}
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between p-2 ">
                  <div>
                    <span>نشانی : </span>
                    <span>{userInfo.address}</span>
                  </div>

                  <div>
                    <span>تلفن : </span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(userInfo.phone)}
                    </span>
                  </div>
                </div>
              </div>
              <div className="text-center py-2">
                مشخصات کالا یا خدمات مورد معامله
              </div>
              <div className="text-center table-responsive  ">
                <table className="table table-bordered border-dark m-0  ">
                  <thead>
                    <tr>
                      <th scope="col">ردیف</th>
                      <th scope="col">کد کالا</th>
                      <th scope="col">شرح کالا یا خدمات</th>
                      <th scope="col">تعداد / مقدار</th>
                      <th scope="col">واحد اندازه گیری</th>
                      <th scope="col">مبلغ واحد (تومان)</th>
                      <th scope="col">مبلغ کل (تومان)</th>
                      <th scope="col">مبلغ تخفیف</th>
                      <th scope="col">مبلغ کل پس از تخفیف (تومان)</th>
                      <th scope="col">جمع مالیات و عوارض (تومان)</th>
                      <th scope="col">
                        جمع مبلغ کل بعلاوه جمع مالیات و عوارض (تومان)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td></td>
                      <td>نشر هوشمند محتوا</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="number-finance">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(amountWithoutVAT)
                        )}
                      </td>
                      <td></td>
                      <td className="number-finance">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(amountWithoutVAT)
                        )}
                      </td>
                      <td className="number-finance">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(amountVAT)
                        )}
                      </td>
                      <td className="number-finance">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(invoice.amount)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6">
                        <div className="d-flex justify-content-between">
                          <span>جمع کل :</span>
                          <span className="pl-2">
                            <span className="pl-2">
                              <i
                                className="fa fa-times"
                                style={{ fontSize: "12px" }}
                              ></i>
                              <i
                                className="fa fa-times"
                                style={{ fontSize: "12px" }}
                              ></i>
                              <i
                                className="fa fa-times"
                                style={{ fontSize: "12px" }}
                              ></i>
                            </span>
                            <span>
                              {helpersNumbers.generateTextPrice(invoice.amount)}
                              تومان
                            </span>

                            <span className="pr-2">
                              <i
                                className="fa fa-times"
                                style={{ fontSize: "12px" }}
                              ></i>
                              <i
                                className="fa fa-times"
                                style={{ fontSize: "12px" }}
                              ></i>
                              <i
                                className="fa fa-times"
                                style={{ fontSize: "12px" }}
                              ></i>
                            </span>
                          </span>
                        </div>
                      </td>
                      <td className="number-finance">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(amountWithoutVAT)
                        )}
                      </td>
                      <td></td>
                      <td className="number-finance">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(amountWithoutVAT)
                        )}
                      </td>
                      <td className="number-finance">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(amountVAT)
                        )}
                      </td>
                      <td className="number-finance">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(invoice.amount)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6">
                        <div className="d-flex justify-content-between align-items-center">
                          <span>شرایط و نحوه فروش :</span>
                          <span className="d-flex  align-items-center">
                            <span className="pl-2 ">نقدی</span>
                            <i
                              className="far fa-check-square"
                              style={{ fontSize: "24px" }}
                            ></i>
                          </span>

                          <span className="d-flex  align-items-center pl-3">
                            <span className="pl-2 ">غیر نقدی</span>
                            <i
                              className="far fa-square"
                              style={{ fontSize: "24px" }}
                            ></i>
                          </span>
                        </div>
                      </td>
                      <td colspan="6" className="text-right">
                        <span>توضیحات : </span>
                        <span>
                          شماره حساب{" "}
                          <span className="letter-spacing-finance-number px-1">
                            ۴۹۱۸۷۳۷۹۷۰
                          </span>{" "}
                          شماره کارت{" "}
                          <span className="letter-spacing-finance-number px-1">
                            {" "}
                            ۶۹۸۲-۷۴۴۱-۳۳۷۹-۶۱۰۴
                          </span>
                          بانک ملت شماره شبا شرکت{" "}
                          <span className="letter-spacing-finance-number px-1">
                            IR۳۳۰-۱۲۰۰۰۰۰۰۰۰۰۴۹۱۸۷۳۷۹۷۰
                          </span>{" "}
                          به ‌نام شرکت فن آوای هوش مصنوعی
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6" className="text-right py-4">
                        مهر و امضا فروشنده
                      </td>
                      <td colspan="6" className="text-right py-4">
                        مهر و امضا خریدار
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="alert alert-primary ">
            <i className="fa fa-info pl-2 "></i>
            <p className="d-inline text-justify">
              برای دریافت فاکتور، با به همراه داشتن مهر سازمان و تنها در روزهای
              شنبه و یک‌شنبه و با هماهنگی قبلی از تاریخ ۰۴ اردیبهشت ساعت ۹ صبح
              الی ۴ بعد از ظهر به آدرس میدان حسن آباد کوچه نعمتی پلاک ۲۰ واحد ۸
              مراجعه کنید.
            </p>
          </div>
        </div>
        <div>
          <span className=" ">
            <Link className="btn btn-primary" to="/finance/invoices">
              بازگشت به صفحه فاکتورها و پیش فاکتورها
            </Link>
          </span>
          <span className="pr-2">
            <span
              className="btn btn-success"
              onClick={() => {
                var prtContent = document.getElementById(
                  "official-invoice-confiner"
                );
                var WinPrint = window.open(
                  "",
                  "",
                  "left=0,top=0,toolbar=1,scrollbars=1,status=0"
                );
                WinPrint.document.write(
                  "<html><head><meta charset='utf-8'><meta http-equiv='X-UA-Compatible' content='IE=edge' /><link href='/assets/css/app.min.css' rel='stylesheet' /><title>پلتفرم تبلیغات هایلات</title></head>"
                );
                WinPrint.document.write(
                  "<body><div id='official-invoice-confiner-printer'>"
                );
                WinPrint.document.write(prtContent.innerHTML);
                WinPrint.document.write("</div></body></html>");
                WinPrint.document.close();
                WinPrint.focus();
                setTimeout(() => {
                  WinPrint.print();
                }, 1000);
              }}
            >
              <i className="fa fa-print pl-2"></i>
              <span>پرینت</span>
            </span>
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="مشاهده فاکتورها و پیش فاکتورها " />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">{generateOfficialInvoice()}</div>
          </div>
        </section>
      </div>
    </>
  );
}
